export const dateFormat = 'Do MMMM YYYY h:mm:ssA Z';

export const defaultPageSize = 50;

export const communityList = [
  {
    text: 'NAS_DAILY_CREATOR_COMMUNITY',
    value: 'NAS_DAILY_CREATOR_COMMUNITY'
  }
];

export const sortOrderList = [
  {
    text: 'Newest to Oldest',
    value: '-1'
  },
  {
    text: 'Oldest to Newest',
    value: '1'
  }
];

export const filterList = [
  {
    text: 'Email',
    value: 'email'
  },
  {
    text: 'Name',
    value: 'fullName'
  },
  {
    text: 'Telegram username',
    value: 'telegramUsername'
  }
];

export const applicationStatus = {
  REJECT: 'Rejected',
  MAYBE: 'Maybe',
  APPROVE: 'Approved',
  PENDING: 'Pending',
  CANCELLED: 'Cancelled'
};

export const applicationStatusList = Object.values(applicationStatus).map(
  (key) => ({
    text: key,
    value: key
  })
);

export const platformsList = [
  { label: 'Whatsapp', value: 'whatsapp' },
  { label: 'Discord', value: 'discord' },
  { label: 'Facebook Group', value: 'facebookGroup' },
  { label: 'Telegram', value: 'telegram' },
  { label: 'Slack', value: 'slack' },
  { label: 'LinkedIn Group', value: 'linkedinGroup' },
  { label: 'Other', value: 'other' }
];

export const launchTimeOptions = [
  { label: 'ASAP ', value: 'asap' },
  { label: 'In the next 30 days', value: 'inTheNext30Days' },
  { label: 'Within 3 months', value: 'within3Months' },
  { label: 'No fixed date', value: 'noFixedDate' }
];

export const categoryListOptions = [
  { label: 'Content Creation', value: 'contentCreation' },
  { label: 'Entrepreneurship', value: 'entrepreneurship' },
  { label: 'Web3', value: 'web3' },
  { label: 'Education', value: 'education' },
  { label: 'Other', value: 'other' }
];

export const reasonToJoinOptions = [
  {
    value: 'learn-form-others',
    label: 'Learn from fellow content creators'
  },
  {
    value: 'build-toolkit',
    label: 'Build a toolkit of tactics to create better content'
  },
  { value: 'find-mentor', label: 'Find mentors who can guide me' },
  {
    value: 'learn-from-videos',
    label: 'Learn from video lessons and live workshops'
  },
  { value: 'other', label: 'Others' }
];

export const restrictedFieldNames = ['_id', 'status', 'subscriptions'];
export const editableFields = ['totalFollowers', 'primarySocialNetwork'];
